<template>
  <div
    style="width: 100%; height: 100%"
    class="print-form"
  >
    <div>
      <h1 class="font-weight-bold">
        {{ document.title }}
      </h1>
    </div>
    <div
      v-for="(block, index) in document.blocks"
      :key="index"
      class="document-blocks"
    >
      <div
        class="gen-doc-table"
        v-html="block.content"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: ["document"],
  mounted() {
    window.print();
    this.$emit("close", false);
  },
};
</script>
<style>
.print-form img {
  max-width: 100%;
}
</style>
